import React from 'react'
import { useState } from 'react'
import { send } from 'emailjs-com'
import Helmet from 'react-helmet'

export default function ContactForm() {
  const [formSubmitSuccessful, setFormSubmitSuccessful] = useState(false)
  const [toSend, setToSend] = useState({
    user_name: '',
    user_email: '',
    user_phone: '',
    message: '',
  })

  let sayUser = 'Complete los campos requeridos (en rojo) y el recaptcha'
  const onSubmit = (e) => {
    e.preventDefault()
    send(
      'service_w9bzzpd',
      'template_vfuskoo',
      toSend,
      'user_niz1VWZc1d5lFgUpI0czV'
    )
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text)
        setFormSubmitSuccessful(true)
      })
      .catch((err) => {
        console.log('FAILED...', err)
        setFormSubmitSuccessful(false)
      })
  }

  if (formSubmitSuccessful) {
    sayUser = 'Mensaje enviado exitosamente'
    ///console.log("HELL YEAH")
  }

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value })
  }

  return (
    <section>
      <div
        id='hero-form'
        className='col-12 mx-auto my-3 hero-div hero-right hero-contain shadow-sm'
      >
        <Helmet>
          <script
            src={`https://www.google.com/recaptcha/api.js?r=${Math.random()}`}
            async
            defer
          ></script>
        </Helmet>
        <div className='hero-info-form hero-info-left d-flex flex-wrap align-items-center col-12 col-md-8'>
          <div className='mx-auto'>
            <h3 className='fs-1 text-center'>¿Necesita más información?</h3>
            <p className='lead fw-bold text-center text-danger'>
              ENVÍE SUS DUDAS O COMENTARIOS
            </p>
          </div>
          <form
            // className='row g-2 px-md-5 px-0'
            className='row g-3 col-12 col-md-8 my-1 mx-auto p-3'
            id='contact-form'
            onSubmit={onSubmit}
          >
            <div className='col-6'>
              <label htmlFor='user_name' className='form-label'>
                Nombre
              </label>
              <input
                type='text'
                name='user_name'
                placeholder='Tu nombre...'
                value={toSend.user_name}
                required
                onChange={handleChange}
              />
            </div>

            <div className='col-6'>
              <label htmlFor='user_email' className='form-label'>
                E-mail
              </label>
              <input
                type='email'
                name='user_email'
                placeholder='Tu e-mail'
                value={toSend.user_email}
                required
                onChange={handleChange}
              />
            </div>

            <div className='col-12'>
              <label htmlFor='user_phone' className='form-label'>
                Teléfono
              </label>
              <input
                type='tel'
                name='user_phone'
                placeholder='10 dígitos'
                value={toSend.user_phone}
                onChange={handleChange}
              />
            </div>

            <div className='col-12'>
              <label htmlFor='message' className='form-label'>
                Mensaje
              </label>
              <textarea
                type='text'
                name='message'
                placeholder='Tu mensaje...'
                value={toSend.message}
                required
                onChange={handleChange}
              />
            </div>
            <div
              className='g-recaptcha'
              data-sitekey='6LdM7R8TAAAAADS0vEwmmZys9OGNwxfsnAdLWW7E'
            ></div>
            <div className='col-12'>
              <button type='submit' className='btn btn-danger btn-lg'>
                Enviar Mensaje
              </button>
            </div>
            <div className='d-block'>
              <p className='py-2 px-3 rounded border border-secondary bg-light fs-6 text-center mx-auto fst-italic'>
                {sayUser}
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  )
}
